import React, { useEffect, useState } from "react";
import { getOnlineRegistration } from "../Service/Api";

const OnlineRegistration = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getOnlineRegistration();
        setData(result);
      } catch (error) {
        console.error("Error fetching online registration data:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="online-reg">
      {data.length > 0 ? (
        data.map((item, index) => (
          <React.Fragment key={index}>
            {(item.attachments && item.attachments.length > 0) ? (
              item.attachments.map((attachment, attachIndex) => (
                <li className="group" key={attachIndex}>
                  <a
                    className="custom-title links-urllink"
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.title}
                  </a>
                  <a
                    href={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${attachment}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="bi bi-paperclip"></i>
                  </a>
                </li>
              ))
            ) : (
              <li className="group" key={`no-attachment-${index}`}>
                <a
                  className="custom-title links-urllink"
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item.title}
                </a>
              </li>
            )}
          </React.Fragment>
        ))
      ) : (
        <p>No registration notices available.</p>
      )}
    </div>
  );
};

export default OnlineRegistration;
